// Firmenlogo für die Kundenliste: Bild aus dem Dateidialog auf Listengröße bringen.
//
// Das Logo wird als Data-URL beim Kunden gespeichert und kommt mit der Kundenliste
// mit — es muss also klein bleiben. Deshalb wird im Browser verkleinert, bevor
// überhaupt etwas zum Server geht.

/** Kantenlänge des gespeicherten Logos (2× der 36px-Anzeige, für scharfe Darstellung). */
export const LOGO_KANTE = 96;

/** Was der Dateidialog annimmt. SVG bleibt außen vor: skaliert nicht über Canvas. */
export const LOGO_TYPEN = 'image/png,image/jpeg,image/webp,image/gif';

/** Grenze für die Datei aus dem Dialog — vor dem Verkleinern. */
export const LOGO_MAX_BYTES = 8 * 1024 * 1024;

export function pruefeLogoDatei(file: { type: string; size: number }): string | null {
  if (!file.type.startsWith('image/')) return 'Bitte ein Bild auswählen (PNG, JPG oder WebP).';
  if (file.type === 'image/svg+xml') return 'SVG wird nicht unterstützt — bitte PNG oder JPG verwenden.';
  if (file.size > LOGO_MAX_BYTES) return 'Das Bild ist zu groß (maximal 8 MB).';
  return null;
}

/**
 * Zielmaße für ein Bild: längste Kante auf `kante`, Seitenverhältnis bleibt.
 * Kleinere Bilder werden nicht hochgerechnet.
 */
export function zielGroesse(breite: number, hoehe: number, kante = LOGO_KANTE): { breite: number; hoehe: number } {
  if (breite <= 0 || hoehe <= 0) return { breite: kante, hoehe: kante };
  const faktor = Math.min(1, kante / Math.max(breite, hoehe));
  return {
    breite: Math.max(1, Math.round(breite * faktor)),
    hoehe: Math.max(1, Math.round(hoehe * faktor)),
  };
}

/** Datei einlesen, verkleinern und als PNG-Data-URL zurückgeben. */
export async function logoAlsDataUrl(file: File, kante = LOGO_KANTE): Promise<string> {
  const quelle = await new Promise<HTMLImageElement>((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => { URL.revokeObjectURL(url); resolve(img); };
    img.onerror = () => { URL.revokeObjectURL(url); reject(new Error('Bild konnte nicht gelesen werden.')); };
    img.src = url;
  });

  const { breite, hoehe } = zielGroesse(quelle.naturalWidth, quelle.naturalHeight, kante);
  const canvas = document.createElement('canvas');
  canvas.width = breite;
  canvas.height = hoehe;
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Bild konnte nicht verarbeitet werden.');
  ctx.drawImage(quelle, 0, 0, breite, hoehe);
  // PNG erhält Transparenz — Logos stehen sonst auf schwarzem Grund.
  return canvas.toDataURL('image/png');
}
